module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/business/bus-product-4-73f5f26eb34513ccc4eb88d5077d254d.jpg";